import * as React from "react";
const SvgRita = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 38 25",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeMiterlimit: 10,
	strokeWidth: 3,
	d: "M11.644 23.225H18.5a1.65 1.65 0 0 0 1.644-1.644V3.91s0-2.305 2.736-2.154c2.736.15 2.592 2.154 2.592 2.154v13.348a1.65 1.65 0 0 0 1.652 1.645h7.224A1.65 1.65 0 0 0 36 17.258V14.58"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "m16.282 19.822-4.545-1.128a.5.5 0 0 1-.28-.18L.17 4.585a.517.517 0 0 1 .071-.717L4.305.578a.524.524 0 0 1 .719.072L16.318 14.6a.46.46 0 0 1 .108.266l.481 4.402a.517.517 0 0 1-.625.553"
}));
export default SvgRita;
